import axios from "axios";
import * as actionType from "../actionTypes";
import apiConstants from "../../constans/apiConstants";
import { toaster } from "../../utils/utils";

// main

const showToastWithDelay = (message) => {
  toaster("error", message);
  setTimeout(() => {
      // toaster(""); 
  }, 5000);
};

export const getTpaPoposal = (cb) => {
  return (dispatch) => {
    dispatch({ type: actionType.LOADER_TRUE });
    axios
      .get(
        `${apiConstants().PROPOSEL_API_URL}api/v1/proposal/ops/get/tpa/waiveOff`,
        
        {
          headers: {
            "Content-Type": "application/json",
            authorization: localStorage.getItem("token"),
          },
        }
      )
      .then((res) => {  
        dispatch({ type: actionType.LOADER_FALSE });
      
      if(res.data.status !=='BAD_REQUEST'){
        if (res.data.body) {
          // toaster("success", res.data.message);
          if (res.data) {
            cb(res.data);
          }
        } else {
          toaster("error", res.data.message);
        }
      }
      else {
          showToastWithDelay(res.data.message); 
          if (res.data) {
            cb(res.data);
          }
      }
      })
      .catch(() => {
        dispatch({ type: actionType.LOADER_FALSE });
      });
  };
};


export const tpaPoposal = (data, cb) => { 
  return (dispatch) => {
    dispatch({ type: actionType.LOADER_TRUE });
    axios
      .post(
        `${apiConstants().PROPOSEL_API_URL}api/v1/proposal/ops/tpa/waiveOff`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: localStorage.getItem("token"),
          },
        }
      )
      .then((res) => {  
        dispatch({ type: actionType.LOADER_FALSE });
      
      if(res.data.status !=='BAD_REQUEST'){ 
        if (res.data.body) {
          toaster("success", res.data.message);
          if (res.data) {
            cb(res.data);
          }
        } else {
          toaster("error", res.data.message);
        }
      }
      else {
          showToastWithDelay(res.data.message); 
            cb(res.data);
      }
      })
      .catch(() => {
        dispatch({ type: actionType.LOADER_FALSE });
      });
  };
};

// update

export const tpaUpdatePoposal = (data, cb) => async (dispatch) => {
  try {   
      const res = await axios.put(`${apiConstants().PROPOSEL_API_URL}api/v1/proposal/ops/update/tpa/waiveOff
      `, data, {
          headers: {
              "Authorization": localStorage.getItem("token"),
            "Content-Type": "application/json",
              },
      }).then((res) => { 
        dispatch({ type: actionType.LOADER_FALSE })
        if(res.data.status !=='BAD_REQUEST'){
          if (res.data.body) {
            toaster("success", res.data.message);
            if (res.data) {
              cb(res.data);
            }
          } else {
            toaster("error", res.data.message);
          }
        }else {
            toaster("error", res.data.message)
        }
    })
      
  } catch (err) {
      console.log(`err`, err)
  }
}

// delete
export const tpaDeletePoposal = (data, cb) => async (dispatch) => {
  const deleteDataId = data.id;
  try {
    dispatch({ type: actionType.LOADER_TRUE });

    const res = await axios
    
      .delete(
        `${
          apiConstants().PROPOSEL_API_URL
        }api/v1/proposal/ops/delete/tpa/waiveOff/${deleteDataId}`,
        {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        }
      )
      .then((res) => {
        dispatch({ type: actionType.LOADER_FALSE })

        if (res && res.data.status === "OK") {
          toaster("success", res.data.message);
        } else {
          toaster("error", res.data.message);
        }
        if (cb) {
          cb(res);
        }
      });
  } catch (err) {
    dispatch({ type: actionType.LOADER_FALSE })
    console.log(`err`, err);
  }
};
